import { defineMessages } from 'react-intl';

export default defineMessages({
  noPermissions: 'Nie masz uprawnień do podglądu tej strony',
});
